// extracted by mini-css-extract-plugin
export var stepActive = "_1x-3";
export var stepCompleted = "_1x-4";
export var stepConnectorLine = "_1x-b";
export var stepIndicatorCircle = "_1x-6";
export var stepIndicatorCircleCompleted = "_1x-7";
export var stepIndicatorCircleDefault = "_1x-8";
export var stepIndicatorTextCompleted = "_1x-9";
export var stepIndicatorTextDefault = "_1x-a";
export var stepPending = "_1x-5";
export var wizardContainer = "_1x-1";
export var wizardContent = "_1x-2";
export var wizardModal = "_1x-0";